import script from "./CameraPhoto.vue?vue&type=script&setup=true&lang=js"
export * from "./CameraPhoto.vue?vue&type=script&setup=true&lang=js"

import "./CameraPhoto.vue?vue&type=style&index=0&id=516b8db0&lang=scss&scoped=true"

import exportComponent from "/Volumes/TRENTDEVELOPMENT/www/classmarker_pre_release_production/web_apps/test-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-516b8db0"]])

export default __exports__